<template>
  <GlobalWindow
    :title="title"
    :visible.sync="visible"
    :confirm-working="isWorking"
    @confirm="confirm"
    :withFooter="withFooter"
  >
    <el-form
      :model="form"
      ref="form"
      :rules="withFooter ? rules : null"
      :disabled="!withFooter"
    >
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item label="物料编码" prop="wlbm">
            <el-input
              maxlength="60"
              v-model="form.wlbm"
              v-trim
              :placeholder="withFooter ? '请输入物料编码' : null"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="批次号" prop="pc">
            <el-input
              maxlength="60"
              v-model="form.pc"
              v-trim
              :placeholder="withFooter ? '请输入批次号' : null"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="订单单位" prop="dddw">
            <el-input
              maxlength="60"
              v-model="form.dddw"
              v-trim
              :placeholder="withFooter ? '请输入订单单位' : null"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="供应商" prop="gysmc">
            <el-input
              maxlength="60"
              v-model="form.gysmc"
              v-trim
              :placeholder="withFooter ? '请输入供应商' : null"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8"
          ><el-form-item label="需求部门" prop="demandDepartment">
            <el-input
              v-model="form.demandDepartment"
              :placeholder="withFooter ? '请输入需求部门' : null"
              @keypress.enter.native="search"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24"
          ><el-form-item label="项目名称" prop="entryName">
            <el-input
              maxlength="110"
              v-model="form.entryName"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              v-trim
              :placeholder="withFooter ? '请输入项目名称' : null"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="24">
          <el-form-item label="物料描述" prop="wlms">
            <el-input
              maxlength="110"
              v-model="form.wlms"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              v-trim
              :placeholder="withFooter ? '请输入物料描述' : null"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item label="备注" prop="remarks">
            <el-input
              maxlength="110"
              v-model="form.remarks"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 5 }"
              v-trim
              :placeholder="withFooter ? '请输入备注' : null"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </GlobalWindow>
</template>

<script>
import { getParentDept } from "@/api/synchronous_data";
import BaseOpera from "@/components/base/BaseOpera";
import GlobalWindow from "@/components/common/GlobalWindow";
export default {
  name: "synchronous_data_addEdit",
  extends: BaseOpera,
  components: { GlobalWindow },
  data() {
    return {
      deptList: [],
      // 表单数据
      form: {
        id: null,
        wlbm: "",
        pc: "",
        demandDepartment:"",
        entryName:"",
        wlms: "",
        remarks: "",
        htsl: "",
        dddw: "",
        gysmc:'',
        cgsqh: "",
        cgsqhxm: "",
      },
      // 验证规则
      rules: {
        wlbm: [{ required: true, message: "请输入物料编码" }],
        pc: [{ required: true, message: "请输入批次号" }],
        demandDepartment: [{ required: true, message: "请输入需求部门" }],
        entryName: [{ required: true, message: "请输入项目名称" }],
        wlms: [{ required: true, message: "请输入物料描述" }],
        remarks: [{ required: true, message: "请输入备注" }],
        htsl: [{ required: true, message: "请输入合同数量" }],
        dddw: [{ required: true, message: "请输入订单单位" }],
        gysmc: [{ required: true, message: "请输入供应商" }],
        cgsqh: [{ required: true, message: "请输入采购申请号" }],
        cgsqhxm: [{ required: true, message: "请输入采购申请行项目" }],
      },
    };
  },
  created() {
    this.config({
      api: "/synchronous_data",
      "field.id": "id",
    });
    // this.getDept();
  },
  methods: {
    getDept() {
      getParentDept().then((res) => {
        this.deptList = res;
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.el-input.is-disabled /deep/ .el-input__inner {
  color: rgba(0, 0, 0, 0.672);
}
.el-textarea.is-disabled /deep/ .el-textarea__inner {
  color: rgba(0, 0, 0, 0.672);
}
</style>